/**
 * @generated SignedSource<<b82b9b38c96bf6b763bd8f21ed441feb>>
 * @relayHash 0f4f3c0dc3fbfd461b30b2edce7ff480
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bd147d7ddd3fe153f2faac37da072abad63284dd1e60a1ad50037b7db7059d8d

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraSprintState = "ACTIVE" | "CLOSED" | "FUTURE" | "%future added value";
export type sprintJqlBuilderBasicInitQuery$variables = {
  cloudId: string;
};
export type sprintJqlBuilderBasicInitQuery$data = {
  readonly jira: {
    readonly jqlBuilder: {
      readonly recentlyUsedSprints: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly displayName: string;
            readonly jqlTerm: string;
            readonly sprint: {
              readonly boardName: string | null | undefined;
              readonly state: JiraSprintState | null | undefined;
            };
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  };
};
export type sprintJqlBuilderBasicInitQuery = {
  response: sprintJqlBuilderBasicInitQuery$data;
  variables: sprintJqlBuilderBasicInitQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "jqlTerm"
},
v4 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v5 = {
  "kind": "ScalarField",
  "name": "state"
},
v6 = {
  "kind": "ScalarField",
  "name": "boardName"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "sprintJqlBuilderBasicInitQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v1/*: any*/),
              "concreteType": "JiraJqlBuilder",
              "kind": "LinkedField",
              "name": "jqlBuilder",
              "plural": false,
              "selections": [
                {
                  "args": (v2/*: any*/),
                  "concreteType": "JiraJqlSprintFieldValueConnection",
                  "kind": "LinkedField",
                  "name": "recentlyUsedSprints",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraJqlSprintFieldValueEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "concreteType": "JiraJqlSprintFieldValue",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v3/*: any*/),
                            (v4/*: any*/),
                            {
                              "concreteType": "JiraSprint",
                              "kind": "LinkedField",
                              "name": "sprint",
                              "plural": false,
                              "selections": [
                                (v5/*: any*/),
                                (v6/*: any*/)
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ],
                  "storageKey": "recentlyUsedSprints(first:5)"
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sprintJqlBuilderBasicInitQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraJqlBuilder",
            "kind": "LinkedField",
            "name": "jqlBuilder",
            "plural": false,
            "selections": [
              {
                "args": (v2/*: any*/),
                "concreteType": "JiraJqlSprintFieldValueConnection",
                "kind": "LinkedField",
                "name": "recentlyUsedSprints",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraJqlSprintFieldValueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraJqlSprintFieldValue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "concreteType": "JiraSprint",
                            "kind": "LinkedField",
                            "name": "sprint",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v6/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "id"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "recentlyUsedSprints(first:5)"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "bd147d7ddd3fe153f2faac37da072abad63284dd1e60a1ad50037b7db7059d8d",
    "metadata": {},
    "name": "sprintJqlBuilderBasicInitQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ea6849d517e657548891da01c0336d4f";

export default node;
